<script setup>
import { required } from 'src/validations'
import { useGlobalStore } from 'src/composables/useGlobalStore'

const { performLogin, authModalTab, loginEmail, loginPassword } = useGlobalStore()
</script>

<template lang="pug">
q-form(@submit="performLogin({ email: loginEmail, password: loginPassword })" ref="form").loginBox
  .full-width.flex.flex-center
    .mainTitle Anmelden
  .column
    .full-width.flex.flex-center.q-my-md(style="margin-top: 80px;")
      .full-width.q-px-lg
        q-input.full-width.login--input(v-model="loginEmail" hide-bottom-space autocomplete="E-mail address" label-color="grey-14" label="E-mail" :rules='[required]')
        q-input.full-width.login--input(v-model="loginPassword" hide-bottom-space autocomplete="current-password" label-color="grey-14" label="Password" type="password" :rules='[required]')
        .forgotText.cursor-pointer.q-mt-md(@click="authModalTab = 'FORGOTTEN_PASSWORD'") Passwort vergessen?
        .full-width.flex.flex-center.q-my-xl
          q-btn(type="submit").loginBtn Anmelden
    .full-width.flex.flex-center.q-mb-md
      .row
        .forgotText Noch nicht Registriert?
        .registerText.cursor-pointer.q-ml-md(@click="authModalTab = 'REGISTRATION'") Registrieren
</template>

<style lang="sass">
.loginBox
  .login--input
    .q-field__native
      color: #9D9DD4
    .q-field__control:before
      border-color: #5C5C73
    .q-field__control:hover:before
      border-color: #757595
    .q-field__control:after
      background: #757595
    .q-field__control.text-negative::after
      background: #C10015 !important
    .q-field__label
      color: #5FEFC0 !important
      font-size: 14px !important
      font-weight: 700
      line-height: 21px
  .forgotText
    font-size: 16px
    font-style: normal
    font-weight: 400
    line-height: 21px
    letter-spacing: 0em
    text-align: left
    color: #9D9DD5

  .q-field__label
    color: #5FEFC0 !important
    font-size: 16px
    font-style: normal
    font-weight: 700
    line-height: 21px
    letter-spacing: 0em
    text-align: left

  .mainTitle
    font-size: 24px
    font-style: normal
    font-weight: 700
    line-height: 31px
    letter-spacing: 0em
    text-align: center
    color: white
  .loginBtn
    display: flex
    flex-direction: row
    justify-content: center
    align-items: center
    padding: 12px 28px
    height: 54px
    width: 100%
    background: #5FEFC0
    border-radius: 10px
    font-size: 20px
    font-style: normal
    font-weight: 600
    line-height: 30px
    letter-spacing: 0em
    text-align: left
  .registerText
    font-size: 16px
    font-style: normal
    font-weight: 700
    line-height: 21px
    letter-spacing: 0em
    text-align: center
    color: #5FEFC0

</style>
